// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-player {
    position: relative;
    display: flex;
    justify-content: center; /* Center content vertically */
    align-items: center; /* Center content horizontally */
    border-left: var(--border-style);
    border-bottom: var(--border-style);
    width: 100%;
    height: 100%; /* Ensure the video player container fills the available height */
}

.play-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
    width: 80px; /* Adjust size as needed */
    height: 80px; /* Adjust size as needed */
    border-radius: 50%;
    background-color: black;
    display: flex;
    align-items: center;
    justify-content: center;
}

.play-button::after {
    content: "";
    display: block;
    width: 0;
    height: 0;
    border-left: 30px solid yellow; /* Adjust size as needed */
    border-top: 15px solid transparent; /* Adjust size as needed */
    border-bottom: 15px solid transparent; /* Adjust size as needed */
    margin-left: 5px; /* Adjust to center horizontally */
}

video {
    width: 100%;
    height: auto; /* Maintain aspect ratio */
    max-width: 100%; /* Ensure the video doesn't exceed the container width */
    max-height: 100%; /* Ensure the video doesn't exceed the container height */
}
`, "",{"version":3,"sources":["webpack://./src/style/video-player.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB,EAAE,8BAA8B;IACvD,mBAAmB,EAAE,gCAAgC;IACrD,gCAAgC;IAChC,kCAAkC;IAClC,WAAW;IACX,YAAY,EAAE,iEAAiE;AACnF;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,oBAAoB;IACpB,WAAW,EAAE,0BAA0B;IACvC,YAAY,EAAE,0BAA0B;IACxC,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,cAAc;IACd,QAAQ;IACR,SAAS;IACT,8BAA8B,EAAE,0BAA0B;IAC1D,kCAAkC,EAAE,0BAA0B;IAC9D,qCAAqC,EAAE,0BAA0B;IACjE,gBAAgB,EAAE,kCAAkC;AACxD;;AAEA;IACI,WAAW;IACX,YAAY,EAAE,0BAA0B;IACxC,eAAe,EAAE,wDAAwD;IACzE,gBAAgB,EAAE,yDAAyD;AAC/E","sourcesContent":[".video-player {\n    position: relative;\n    display: flex;\n    justify-content: center; /* Center content vertically */\n    align-items: center; /* Center content horizontally */\n    border-left: var(--border-style);\n    border-bottom: var(--border-style);\n    width: 100%;\n    height: 100%; /* Ensure the video player container fills the available height */\n}\n\n.play-button {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    pointer-events: none;\n    width: 80px; /* Adjust size as needed */\n    height: 80px; /* Adjust size as needed */\n    border-radius: 50%;\n    background-color: black;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.play-button::after {\n    content: \"\";\n    display: block;\n    width: 0;\n    height: 0;\n    border-left: 30px solid yellow; /* Adjust size as needed */\n    border-top: 15px solid transparent; /* Adjust size as needed */\n    border-bottom: 15px solid transparent; /* Adjust size as needed */\n    margin-left: 5px; /* Adjust to center horizontally */\n}\n\nvideo {\n    width: 100%;\n    height: auto; /* Maintain aspect ratio */\n    max-width: 100%; /* Ensure the video doesn't exceed the container width */\n    max-height: 100%; /* Ensure the video doesn't exceed the container height */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
